var SitePage = require('../views/masters/SitePage');
var $ = require('jquery');
var UIAccordeon = require('../modules/ui/uiaccordeon');

/**
 * Especials
 * @constructor
 * @description represent Home Page
 * @extends SitePage
 * @param {Object} options - object contain any attributes
 */

function Categories(options){
    SitePage.call(this);
    this.options = options;
}

Categories.prototype = $.extend(Object.create(SitePage.prototype), {

  constructor: Categories,

  /**
   * Executes when document DOM Tree is ready.
   */
  ready: function() {
    console.log("Ready: Categories");
    SitePage.prototype.ready.call(this);

    $('.ui-accordion').UIAccordeon();
  },

  /**
   * Executes when the window is fully loaded.
   */
  load: function(){
    console.log("Load: Categories");
  }

});

// Create a instace of this page;
new Categories({ data: {} });
